<app-tabs>
  <app-products-tab></app-products-tab>
</app-tabs>